export const DETALHE_HOMONIMO = [
  {
    "cpf": "00000223140",
    "nomeMae": "NZV WVHXLMSVXRWZ",
    "situacao": "0",
    "municipio": "SANTA BARBARA D'OESTE",
    "uf": "SP",
    "tipoHomonimia": "HOMONIMO_MAIS_QUE_PERFEITO"
  },
  {
    "cpf": "02867497183",
    "nomeMae": "NZV WVHXLMSVXRWZ",
    "situacao": "0",
    "municipio": "SANTA BARBARA D'OESTE",
    "uf": "SP",
    "tipoHomonimia": "HOMONIMO_MAIS_QUE_PERFEITO"
  }
];
